export const isProduction = import.meta.env.VITE_APP_STAGE === 'production'
export const isStage = import.meta.env.VITE_APP_STAGE === 'stage'
export const isDevelopment = import.meta.env.VITE_APP_STAGE === 'development'
export const isLive = ['production', 'stage'].includes(import.meta.env.VITE_APP_STAGE)
